import { UrlApi } from "../../../../../services/apirest";
import { buildQueryParams } from "../utils/buildQueryParams";

export const getCuentaCorriente = async (cliente, filtros) => {
  const query = buildQueryParams(filtros);
  console.log("Props del cliente: ", cliente);
  const response = await fetch(
    `${UrlApi}/comprobantes/ledger/${cliente.id}/${cliente.id_negocio_cliente}?${query}`,
  );
  console.log(cliente);
  if (!response.ok) throw new Error("Ocurrio un obtener la cuenta corriente");

  return await response.json();
};
